'use strict';

var _ = require('lodash');
var $ = require('jquery');
var PubSub = require('tscom-pubsub');
var template = require('../templates/vote-detail.ejs');

var VoteDetailView = require('standard-vote/app/scripts/views/vote-detail');

var voteButtons = require('../constants').voteButtons;

module.exports = VoteDetailView.extend({

    render: function() {

        var voteLimit = parseInt(this.cms.get('settings').vote_limit);

        this.$el.html(template(_.extend(this.model.toJSON(), {
            text: this.cms.get('text')['views_vote'],
            design: this.cms.get('text')['design'],
            model: this.collection.indexOf(this.model),
            length: this.collection.length,
            voteButtons: voteButtons,
            votesLeft: voteLimit - this.auth.getSubmittedVotes()
        })));

        //handle rendering the close button on IE 11
        var video = this.$el.find('iframe');
        var src = video.attr('src');
        video.attr('src', src + '?wmode=transparent');

        return this;
    },

    castVote: function(e) {
      
        e.preventDefault();

        // don't submit vote for inactive
        if (this.model.get('eliminated') == '1') return;
        if($(e.currentTarget).hasClass('disabled')) return;

        var voteCount = null;
        var target = $(e.currentTarget);

        if(target.hasClass('ten')) voteCount = voteButtons.TEN;
        else if(target.hasClass('twenty')) voteCount = voteButtons.TWENTY;
        else if(target.hasClass('thirty')) voteCount = voteButtons.THIRTY;
        else if(target.hasClass('forty')) voteCount = voteButtons.FORTY;

        var evt = {
            event: 'button_click',
            action: 'vote',
        };

        PubSub.trigger('trackGoogle', evt);
        PubSub.trigger('castVote', voteCount);
    },

    renderedToDOM: function() {
        if (window.FB) {
            var videoContainer = this.$('.gallery');
            FB.XFBML.parse(videoContainer.get(0));
            window.FB.XFBML.parse();
        }
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/vote-detail.js